export enum Scopes {
    SessionsWrite = 'sessions.write',
    UsersRead = 'users.read',
    UsersWrite = 'users.write',
    TeamsRead = 'teams.read',
    TeamsWrite = 'teams.write',
    DatabasesRead = 'databases.read',
    DatabasesWrite = 'databases.write',
    CollectionsRead = 'collections.read',
    CollectionsWrite = 'collections.write',
    TablesRead = 'tables.read',
    TablesWrite = 'tables.write',
    AttributesRead = 'attributes.read',
    AttributesWrite = 'attributes.write',
    ColumnsRead = 'columns.read',
    ColumnsWrite = 'columns.write',
    IndexesRead = 'indexes.read',
    IndexesWrite = 'indexes.write',
    DocumentsRead = 'documents.read',
    DocumentsWrite = 'documents.write',
    RowsRead = 'rows.read',
    RowsWrite = 'rows.write',
    FilesRead = 'files.read',
    FilesWrite = 'files.write',
    BucketsRead = 'buckets.read',
    BucketsWrite = 'buckets.write',
    FunctionsRead = 'functions.read',
    FunctionsWrite = 'functions.write',
    SitesRead = 'sites.read',
    SitesWrite = 'sites.write',
    LogRead = 'log.read',
    LogWrite = 'log.write',
    ExecutionRead = 'execution.read',
    ExecutionWrite = 'execution.write',
    LocaleRead = 'locale.read',
    AvatarsRead = 'avatars.read',
    HealthRead = 'health.read',
    ProvidersRead = 'providers.read',
    ProvidersWrite = 'providers.write',
    MessagesRead = 'messages.read',
    MessagesWrite = 'messages.write',
    TopicsRead = 'topics.read',
    TopicsWrite = 'topics.write',
    SubscribersRead = 'subscribers.read',
    SubscribersWrite = 'subscribers.write',
    TargetsRead = 'targets.read',
    TargetsWrite = 'targets.write',
    RulesRead = 'rules.read',
    RulesWrite = 'rules.write',
    MigrationsRead = 'migrations.read',
    MigrationsWrite = 'migrations.write',
    VcsRead = 'vcs.read',
    VcsWrite = 'vcs.write',
    AssistantRead = 'assistant.read',
    TokensRead = 'tokens.read',
    TokensWrite = 'tokens.write',
}